/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: true,
    saving: false,
    errors: null,
    openDeleteDialog: false,
    selectedChat: "bnnadminpvt@conference.bnn.adtsoft.com"
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'REQUEST_CHAT':
            return {
                ...state,
                inProgress: false,
                dataList: action.payload
            };
        case 'SEARCH_CHAT':
            return {
                ...state,
                selectedChat: action.payload
            };
        case 'CHATS_PAGE_UNLOADED':
        case 'CHAT_PAGE_UNLOADED':
            return {...defaultState};
        case 'ASYNC_START':
            if (action.subtype === 'REQUEST_CHAT'
                || action.subtype === 'SEARCH_CHAT') {
                return { ...state, inProgress: true };
            } else if (action.subtype === 'SUBMIT_TEMPLATE'
                || action.subtype === 'DELETE_TEMPLATE'
                || action.subtype === 'PREVIEW_TEMPLATE'
                || action.subtype === 'SEND_TEMPLATE'
                ) {
                return { ...state, saving: true };
            }
            break;
    }

    return state;
};